export class ItemAuctionInfo {
  equipId: number;
  unitType: string;
  quantity: number;
  onlineBidding: boolean;
  priorityBidding: boolean;
  dealerDismantlerReasonId: number;
  dealerDismantlerReason: string;

  // derived
  saleByUnit: string;
  onlineBiddingEnabled: string;
  priorityBiddingEnabled: string;
  dealerDismantlerEnabled: string;

  public static fromJson(itemAuctionInfoJson: any): ItemAuctionInfo {
    const itemAuctionInfo: ItemAuctionInfo = Object.assign(new ItemAuctionInfo(), itemAuctionInfoJson);
    itemAuctionInfo.saleByUnit = !!itemAuctionInfo.unitType && !!itemAuctionInfo.quantity ? 'Yes' : 'No';
    itemAuctionInfo.onlineBiddingEnabled = !!itemAuctionInfo.onlineBidding ? 'Yes' : 'No';
    itemAuctionInfo.priorityBiddingEnabled = itemAuctionInfo.priorityBidding ? 'Yes' : 'No';
    itemAuctionInfo.dealerDismantlerEnabled = !!itemAuctionInfo.dealerDismantlerReasonId ? 'Yes' : 'No';
    return itemAuctionInfo;
  }

  public clone(): ItemAuctionInfo {
    return ItemAuctionInfo.fromJson(JSON.parse(JSON.stringify(this)));
  }

  public isSaleByUnitInfoValid(): boolean {
    return !!this.unitType && !!this.quantity || !this.unitType && !this.quantity;
  }

  translateToBoolean() {
    this.onlineBidding = this.onlineBiddingEnabled === 'Yes';
    this.priorityBidding = this.priorityBiddingEnabled === 'Yes';
  }
}
